import(/* webpackMode: "eager", webpackExports: ["ClientRoot"] */ "/vercel/path0/app/client-root.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@radix-ui/themes/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
